import { Paper, Stack, Text } from '@mantine/core';
import type { Practice } from './types/rbac';
import { PracticeFilters } from './components/PracticeFilters';
import { PracticeTable, type PracticeSortColumn } from './components/PracticeTable';

interface PracticesPageProps {
  practices: Practice[];
  filteredPractices: Practice[];
  searchQuery: string;
  onSearchChange: (value: string) => void;
  statusFilter: string | null;
  onStatusChange: (value: string | null) => void;
  onViewSettings: (practice: Practice) => void;
  onCreatePractice: () => void;
  canCreatePractice?: boolean;
  sortColumn: PracticeSortColumn;
  sortDirection: 'asc' | 'desc';
  onSort: (column: PracticeSortColumn) => void;
}

export function PracticesPage({
  practices: _practices,
  filteredPractices,
  searchQuery,
  onSearchChange,
  statusFilter,
  onStatusChange,
  onViewSettings,
  onCreatePractice,
  canCreatePractice = false,
  sortColumn,
  sortDirection,
  onSort,
}: PracticesPageProps): JSX.Element {
  return (
    <Stack gap="md">
      <PracticeFilters
        searchQuery={searchQuery}
        onSearchChange={onSearchChange}
        status={statusFilter}
        onStatusChange={onStatusChange}
        onCreatePractice={onCreatePractice}
        canCreatePractice={canCreatePractice}
      />

      <Paper p="lg" withBorder>
        {filteredPractices.length === 0 ? (
          <Text c="gray.6" ta="center" py="xl">
            No practices found
          </Text>
        ) : (
          <PracticeTable
            practices={filteredPractices}
            onViewSettings={onViewSettings}
            sortColumn={sortColumn}
            sortDirection={sortDirection}
            onSort={onSort}
          />
        )}
      </Paper>
    </Stack>
  );
}
